import Axios from "axios"
import Qs from "qs"

export const externalApiAxiosInstance = Axios.create({
    paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: "comma" })
    },
})
